import { Alert, AlertTitle } from "@mui/material";
import React from "react";

const IndicationCreationCompte = () => {
  return (
    <>
      <Alert variant="outlined" severity="info">
        <AlertTitle>
          <b>Indication</b>
        </AlertTitle>
        Pour pouvoir postuler à une offre, vous devez d’abord disposer d’un
        compte.
        <br />
        <br />
        - Si vous n’avez pas encore de compte, veuillez en créer un.
        <br />
        - Lors de l’inscription, choisissez le type de compte correspondant à
        votre statut :
        <br />
        <li>
          <b>Association de volontariat</b>
        </li>
        <li>
          <b>Consultant</b>
        </li>
        <li>
          <b>Agex DECIM</b>
        </li>
      </Alert>
    </>
  );
};

export default IndicationCreationCompte;
